import React from 'react';

import { FileText } from 'lucide-react';

import FileGlb from '../../../../src/assets/FileGlb.svg?react';
import FileObj from '../../../../src/assets/FileObj.svg?react';

export const getFileIcon = (fileName: string): React.ReactElement => {
  const extension = fileName.split('.').pop()?.toLowerCase();

  switch (extension) {
    case 'obj':
      return <FileObj />;
    case 'glb':
      return <FileGlb />;
    default:
      return <FileText size={24} />;
  }
};
